<template>
  <div class="ChecklistPaneFilesActionBar">
    <app-button class="mr-2"
                type="icon"
                @click="deselectAllAttachedFiles">
      <app-icon-ds
        icon="xmark"
        size="xs"
      />
    </app-button>
    <h4 class="text-grey-800">
      {{$t('project.checklist.dialogs.ChecklistPaneFilesActionBar.attachedFileCount', { files: computedSelectedAttachedFiles.length }, computedSelectedAttachedFiles.length)}}
    </h4>
    <v-divider vertical class="mx-4 my-2"></v-divider>
    <div class="my-1">
      <ChecklistTableTaskAttachedFilesItemMenu :mnemo="mnemo"
                    :file="computedSelectedAttachedFiles[0]"
                    :multiFiles="computedSelectedAttachedFiles"
                    actionBar
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import ChecklistTableTaskAttachedFilesItemMenu from '@/project/checklist/table/ChecklistTableTaskAttachedFilesItemMenu.vue'
import { RESET_SELECTED_ATTACHED_FILE } from '@/store/modules/checklist/mutation_types'
export default {
  name: 'ChecklistPaneFilesActionBar',
  components: { ChecklistTableTaskAttachedFilesItemMenu },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    selectionModel: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    ...mapState('checklist', ['selectedAttachedFiles']),
    // Use store selectedAttachedFiles as default if selectionModel is not provided
    computedSelectedAttachedFiles () {
      return this.selectionModel ? this.selectionModel : this.selectedAttachedFiles
    },
  },
  methods: {
    deselectAllAttachedFiles () {
      if (this.selectionModel) {
        this.$emit('input', [])
      } else {
        this.$store.commit(`checklist/${RESET_SELECTED_ATTACHED_FILE}`)
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .ChecklistPaneFilesActionBar {
    display: flex;
    align-items: center;
    padding: 0 8px;
    border: 1px solid rgb(var(--v-theme-primary));
    border-radius: 8px;
    flex-wrap: wrap;
  }
</style>
